import React, { Component } from 'react';

export default class ErrorBox extends Component {
	constructor(props){
		super(props);
		this.state={
			
		}
		this.errorGone = this.errorGone.bind(this);
	}

	componentDidMount() {
		
	}

	errorGone() {
		this.props.closeError();
	}


	render() {
		return(<div>
				<div className="randomErrorBox">
					<div className="errorContianer">
						<div style={{color:'red', fontSize:'20px'}}> Error:</div>
						<div style={{fontSize:'14px', marginTop:'10px', whiteSpace: 'pre-line'}}>{this.props.errorText}</div>
						<div style={{textAlign:'right', marginTop:'10px'}}>
							<button className="btn btn-default" onClick={this.errorGone}>Ok</button>
						</div>
					</div>
				</div>
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/commons/ErrorBox.js